<template>
  <div class="ele-body teacher-archive-types">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>教师档案类型设置</span>
        <el-button type="primary" size="small" icon="el-icon-plus" class="ele-btn-icon" @click="openTypeDialog('major')">新增大类</el-button>
      </div>
      <el-table v-loading="loading" :data="typeTree" row-key="id" border stripe default-expand-all :tree-props="{ children: 'children' }">
        <el-table-column type="index" width="55" align="center" />
        <el-table-column prop="typeName" label="档案类型" min-width="260" show-overflow-tooltip />
        <el-table-column label="层级" width="100" align="center">
          <template #default="{ row }">{{ isMajor(row) ? '大类' : '小类' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template #default="{ row }">
            <el-link v-if="isMajor(row)" type="success" :underline="false" icon="el-icon-plus" @click="openTypeDialog('minor', null, row)">
              新增小类
            </el-link>
            <el-link type="primary" :underline="false" icon="el-icon-edit" @click="openTypeDialog(isMajor(row) ? 'major' : 'minor', row)"
              >修改</el-link
            >
            <el-popconfirm :title="`确定要删除此档案${isMajor(row) ? '大类' : '小类'}吗？`" @onConfirm="deleteType(row)" class="ele-action">
              <el-link slot="reference" type="danger" :underline="false" icon="el-icon-delete">删除</el-link>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="
        typeForm.id ? `修改${typeForm.level === 'major' ? '档案大类' : '档案小类'}` : `新增${typeForm.level === 'major' ? '档案大类' : '档案小类'}`
      "
      :visible.sync="typeDialogVisible"
      width="430px"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
    >
      <el-form ref="typeForm" :model="typeForm" :rules="typeRules" label-width="90px">
        <el-form-item label="类型名称:" prop="typeName">
          <el-input v-model.trim="typeForm.typeName" maxlength="30" show-word-limit placeholder="请输入类型名称" />
        </el-form-item>
        <el-form-item v-if="typeForm.level === 'minor'" label="所属大类:">
          <el-input :value="typeForm.parentName" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="typeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveType">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getTeacherArchivesTypeList, addTeacherArchivesType, updateTeacherArchivesType, deleteTeacherArchivesType } from '@/config/api';

  const getListData = (res) => {
    const data = res.data || [];
    return Array.isArray(data) ? data : data.records || data.list || [];
  };

  export default {
    name: 'TeacherArchiveTypes',
    data() {
      return {
        loading: false,
        typeTree: [],
        typeDialogVisible: false,
        typeForm: {},
        typeRules: {
          typeName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
        },
      };
    },
    created() {
      this.loadTypeTree();
    },
    methods: {
      loadTypeTree() {
        this.loading = true;
        getTeacherArchivesTypeList({ typeName: '', parentId: 0 })
          .then((res) => {
            if (res.data.resCode == 200) {
              const majors = getListData(res.data);
              return Promise.all(
                majors.map((major) => {
                  if (Array.isArray(major.children)) return major.children;
                  return getTeacherArchivesTypeList({ typeName: '', parentId: major.id }).then((childRes) => {
                    if (childRes.data.resCode != 200) throw new Error(childRes.data.resMsg || '获取档案小类失败');
                    return getListData(childRes.data);
                  });
                })
              ).then((childrenList) => {
                this.typeTree = majors.map((major, index) =>
                  Object.assign({}, major, {
                    children: (childrenList[index] || []).map((child) =>
                      Object.assign({}, child, {
                        parentId: child.parentId || major.id,
                        parentName: major.typeName,
                      })
                    ),
                  })
                );
              });
            } else {
              throw new Error(res.data.resMsg);
            }
          })
          .catch((e) => this.$message.error(e.message))
          .finally(() => {
            this.loading = false;
          });
      },
      isMajor(row) {
        return !row.parentId || String(row.parentId) === '0';
      },
      openTypeDialog(level, row, parentRow) {
        this.typeForm = Object.assign(
          {
            level: level,
            parentId: level === 'minor' && parentRow ? parentRow.id : 0,
            parentName: level === 'minor' && parentRow ? parentRow.typeName : '',
          },
          row || {}
        );
        this.typeDialogVisible = true;
      },
      saveType() {
        this.$refs.typeForm.validate((valid) => {
          if (!valid) return;
          const formData = new FormData();
          formData.append('typeName', this.typeForm.typeName);
          formData.append('parentId', this.typeForm.level === 'minor' ? this.typeForm.parentId : 0);
          if (this.typeForm.id) formData.append('id', this.typeForm.id);
          const request = this.typeForm.id ? updateTeacherArchivesType(formData) : addTeacherArchivesType(formData);
          request.then((res) => {
            if (res.data.resCode == 200) {
              this.$message.success(res.data.resMsg || '保存成功');
              this.typeDialogVisible = false;
              this.loadTypeTree();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      deleteType(row) {
        const formData = new FormData();
        formData.append('id', row.id);
        deleteTeacherArchivesType(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message.success(res.data.resMsg || '删除成功');
            this.loadTypeTree();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .teacher-archive-types >>> .el-card {
    margin-bottom: 15px;
  }

  .teacher-archive-types >>> .el-alert {
    margin-bottom: 15px;
  }
</style>
